import "./hb-account.module.css";
import { html } from "lit-html";

export default (user) => html`
    <form id="hb-account" class="hidden space-y-4 pb-10">
        <p
            class="mt-5 mb-3 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
            <strong>Always FREE</strong> for Humans
        </p>
        <div
            class="w-full max-w-ful p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
            <h5
                class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">
                Heart of Silver ℹ️
            </h5>
            <div class="flex items-baseline text-gray-900 dark:text-white">
                <span class="text-3xl font-semibold">$</span>
                <span class="text-5xl font-extrabold tracking-tight">0</span>
                <span
                    class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400"
                    >USD / month</span
                >
            </div>
            <ul role="list" class="space-y-5 my-7">
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Aura Ring</strong> around your Avatar based on
                        your <em>Kiitos Frequency</em> around
                        <strong>Zero</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Silver Aura</strong> around your Beating
                        Heart</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Unlimited Cryptographic On-Device
                        <strong>Lockers</strong> for Complete Privacy</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Unlimited Minting and Mining of
                        <strong>Non-Beating</strong> B-Chests with
                        Blockchain-Level Security (QR Code or 3B Crystal)</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Unlimited On-Device Storage of B-Chests inside
                        <strong>HeartBank® Titanium Vault</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Unlimited On-Device
                        <strong>Basic Aquarius™ AI</strong> with Chat, Voice, and
                        Vision</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Unlimited On-Device <strong>Basic AI Voice</strong>,
                        <strong>AI Image</strong>, and
                        <strong>AI Video</strong> Generation of HeartBank®
                        Jewels</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >24x7 Human Support via <strong>Email</strong></span
                    >
                </li>
            </ul>
            <button
                type="button"
                disabled
                class="inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 justify-center w-full text-center">
                ✅ Your Email has been verified
            </button>
        </div>
        <p
            class="mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            AI capabilities depend on your device hardware ℹ️
        </p>
        <br />
        <div>
            <label
                for="hb-account-displayName"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Your Display Name ℹ️
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="name"
                    id="hb-account-displayName"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.displayName
                        ? user.displayName
                        : "Enter Display Name"}" />
                <button
                    id="hb-account-displayName-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div class="hidden">
            <label
                for="hb-account-x"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Your X Handle ℹ️
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="name"
                    id="hb-account-x"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.x ? user.x : "Enter X Username"}" />
                <button
                    id="hb-account-x-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div class="hidden">
            <label
                for="hb-account-fb"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Your Facebook Handle ℹ️
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="name"
                    id="hb-account-fb"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.fb
                        ? user.fb
                        : "Enter Facebook Username"}" />
                <button
                    id="hb-account-fb-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div>
            <label
                for="hb-account-email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Your Email Address
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="email"
                    autocomplete="email"
                    id="hb-account-email"
                    value="${localStorage.getItem("emailForUpdate") || ""}"
                    class="bg-gray-50 border outline-0 border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.email || "thank@heartbank.com"}" />
                <button
                    type="submit"
                    class="${localStorage.getItem("emailForUpdate")
                        ? "mr-1"
                        : ""} text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    ${localStorage.getItem("emailForUpdate")
                        ? "Resend"
                        : "Update"}
                </button>
                <button
                    id="hb-account-email-btn"
                    type="button"
                    class="${localStorage.getItem("emailForUpdate")
                        ? ""
                        : "hidden"} text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Cancel
                </button>
            </section>
        </div>
    </form>
`;
